import firebase from 'firebase'

export default {
  state: {
    session: {
      token: null,
      user: {
        id: '',
        name: null,
        username: null,
        type: null
      }
    }
  },
  getters: {
    session(state) {
      return state.session
    },
    isLoggedIn(state) {
      return !!state.session.token
    }
  },
  mutations: {
    setSession(state, session) {
      state.session = session
    },
    clearSession(state) {
      state.session.token = null
      state.session.user.id = ''
      state.session.user.name = ''
      state.session.user.username = ''
      state.session.user.type = ''
    }
  },
  actions: {
    session({ commit }, { email, password }) {
      commit('clearError')
      commit('setLoading', true)

      return new Promise((resolve, reject) => {
        firebase.auth().signInWithEmailAndPassword(email, password)
          .then(data => {
            if (data.user) {
              commit('setSession', {
                token: data.user.refreshToken,
                user: {
                  id: data.user.uid,
                  name: data.user.displayName,
                  username: data.user.email,
                  type: null
                }
              })
              resolve(data)
            }
            commit('setError', data.message)
            reject(data.message)
          })
          .catch(err => {
            commit('setError', err)
            reject(err)
          })
          .finally(() => commit('setLoading', false))
      })
    },
    logOff({ commit }) {
      commit('clearError')
      return new Promise((resolve, reject) => {
        firebase.auth().signOut()
          .then(() => {
            commit('clearSession')
            resolve()
          })
          .catch(err => {
            commit('clearSession')
            reject(err)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/session/index.js